/* eslint-disable new-cap */
<template>
  <v-container  fluid >
    <div class="choiceplayback white--text">
        <div id="loading"
            v-if="loading">
            <v-progress-circular indeterminate size=48 color="white" >
            </v-progress-circular>
        </div>
      <error-messages v-show="!bEnablePlayback"
        :bSceneDoesntExist="bSceneDoesntExist"
        @ttsNotSupported="ttsNotSupported"
      ></error-messages>
      <v-card v-show="!bTTSEnabled">
        <div class="headline">Incompatible Browser</div><br>
        <div>Sorry, your browser doesn't support text to speech. Please use a different browser.</div><br><br>
      </v-card >
      <v-card v-show="!bLocalStorageAvailable">
        <div class="headline">Cookies Disabled</div><br>
        <div>Please enable cookies for this site.  It can't work without them.</div><br><br>
      </v-card >
    <div v-show="bEnablePlayback">
      <text-input v-show="displayTextBar"
      ref="textInput"
        @input="onTextChanged"
        @timeout="onTimeout"
        @blocked="onBlocked"
      ></text-input>
       <div class="buttonoverlay" v-if="displayEndPrompt && !html.length">
          <v-layout row wrap align-center>
            <v-flex class="text-xs-center">
              <v-btn v-if="bPlayAgainAvailable" v-on:click="onPlayAgain()">{{bFinished}}</v-btn>
              <!-- tag="button" removes underline link css by using button css -->
              <router-link tag="button" :to="{ name: 'edit', params: { id: id }}"><v-btn>Edit</v-btn></router-link>
            </v-flex>
          </v-layout>
         </div>
        <div class="buttonoverlay" v-if="displayedMatches.length && !html.length">
          <v-layout row wrap align-center>
            <v-flex class="text-xs-center">
              <div v-for="(match, index) in displayedMatches" :key="index">
                <v-btn v-on:click="choicePicked(index)">
                    {{displayedMatches[index]}}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </div>

        <character-player
          v-show="showCharacterPlayer"
          ref="characterPlayer"
          @characterClick="onClickCharacter"
          @loading="onLoading"
        ></character-player>

        <v-container fill-height>
          <div class="storytext" ref="htmlDisplay"></div>
        </v-container>

        <div class="notoverlayed" v-if="displayedMatches.length && html.length">
          <v-layout row wrap align-center>
            <v-flex class="text-xs-center">
              <div v-for="(match, index) in displayedMatches" :key="index">
                <v-btn v-on:click="choicePicked(index)">
                    {{displayedMatches[index]}}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </div>
       <div class="notoverlayed" v-if="displayEndPrompt && html.length">
          <v-layout row wrap align-center>
            <v-flex class="text-xs-center">
              <v-btn v-if="bPlayAgainAvailable" v-on:click="onPlayAgain()">{{bFinished}}</v-btn>
              <!-- tag="button" removes underline link css by using button css -->
              <router-link tag="button" :to="{ name: 'edit', params: { id: id }}"><v-btn>Edit</v-btn></router-link>
            </v-flex>
          </v-layout>
         </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import ErrorMessages from '@/components/ErrorMessages'
import Scene from '../../tts/scene'
import Clip from '../../tts/clip'
import Voice from '../../tts/voice'
import helper from '../../helper'
import {SmoothContext} from 'smooth-script'
import TextInput from './TextInput'
import CharacterPlayer from './CharacterPlayer'
import sanitizeHtml from 'sanitize-html'
export default {
  name: 'dialogue-playback',
  components: {
    'text-input': TextInput,
    'character-player': CharacterPlayer,
    'error-messages': ErrorMessages
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      face: {},
      currentId: null,
      displayEndPrompt: false,
      displayTextBar: false,
      loading: false,
      bModifiedScene: false,
      voiceIndexRotater: 0,
      displayedMatches: [],
      bBrowserCompatible: true,
      bLocalStorageAvailable: true,
      bTTSEnabled: true,
      showCharacterPlayer: true,
      picked: null,
      choiceButtonText: 'Choose',
      randomTextBarId: null,
      bEnablePlayback: true,
      bSceneDoesntExist: false,
      bPlayAgainAvailable: false,
      bFinished: '',
      html: '',
      onFinishedTTS: null
    }
  },
  computed: {
    initialized () {
      return this.$store.getters['main/bInitialized']
    }
  },
  methods: {
    ttsNotSupported: function () {
      this.bEnablePlayback = false
    },
    onPlayAgain: function (index) {
      this.onPlay()
      this.onHideMatches()
    },
    choicePicked: function (index) {
      this.bPlayAgainAvailable = true
      var choice = this.displayedMatches[index]
      this.story.submitInput(choice, true)
      this.onClearHTML()
      this.onHideMatches()
    },
    onTextChanged (data) {
      this.bPlayAgainAvailable = true
      this.story.submitInput(data.text, data.bIsFinal)
    },
    onLoading: function (bIsLoading) {
      this.loading = bIsLoading
    },
    onTimeout: function () {
      this.story.submitInput(SmoothContext.SILENT_OPTION_STRING, true)
    },
    onBlocked: function () {
      this.story.speechRecognitionBlocked()
    },
    onEdit: function () {
      this.$router.push({ path: `/edit/${this.id}` })
    },
    onClickCharacter: function () {
      if (Scene.isPlaying()) {
        Scene.stop()
        if (this.onFinishedTTS) {
          this.onFinishedTTS()
          this.onFinishedTTS = null
        }
      } else if (this.$refs.characterPlayer.mobileStalled) {
        this.story.play()
      }
    },
    onInitialized: function () {
      if (!this.bBrowserCompatible) {
        console.warn('Browser not compatible')
        return
      }
      this.$store.dispatch('main/setCurrentChatId', this.currentId)
        .then((data) => {
          if (!data) {
            this.bSceneDoesntExist = true
            this.loading = false
            this.bEnablePlayback = false
            this.story = new SmoothContext()
          } else {
            var copy = JSON.parse(JSON.stringify(data))
            this.story = new SmoothContext(copy)
          }
          this.story.play()

          // Hack to make single-page scenes (like samples) not display the Play Again/Edit
          // If executePreambleAndPlay plays all the way through, displayEndPrompt will get set
          // to true immediately and then countered by this.
          this.displayEndPrompt = false
        })
    },
    onPlay: function () {
      this.onClearHTML()
      this.onFinishedTTS = null
      this.story = new SmoothContext(this.story.defaultFile)
      this.story.play()
      this.bFinished = ''
      this.displayEndPrompt = false
    },
    onAppendHTML: function (data) {
      if (data.html) {
        // Prevent XSS attacks with sanizizeHTML
        this.html += sanitizeHtml(data.html)
        this.$refs.htmlDisplay.innerHTML = this.html
      }
    },
    onClearHTML: function () {
      this.html = ''
      this.showCharacterPlayer = this.story.currentFaceId !== null
      this.$refs.htmlDisplay.innerHTML = this.html
    },
    onDisplayMatches: function (options) {
      if (options.displayText.length) {
        // counting on VUE to sanitize the button labels and prevent XSS attacks.
        this.displayedMatches = options.displayText
      }
    },
    onHideMatches: function () {
      this.displayEndPrompt = false
      this.displayedMatches = []
    },
    onStartListening: function (locale) {
      this.displayTextBar = true
      this.randomTextBarId = Math.random()
    },
    onStopListening: function () {
      var randomId = this.randomTextBarId
      setTimeout(() => {
        if (randomId === this.randomTextBarId) {
          this.displayTextBar = false
        }
      }, 300)
    },
    onClipStartEvent: function () {
      this.showCharacterPlayer = true
    },
    onFaceRequested: function (args) {
      this.$refs.characterPlayer.loadCharacter(args.id, args.onLoaded, args.onError)
    },
    onFinished: function () {
      this.bFinished = 'Play Again'
      this.displayEndPrompt = true
    },
    clipFromText (text, faceId, voice) {
      var clip = new Clip()
      clip.voice = voice
      clip.faceId = faceId
      clip.updateText(text)
      return clip
    },
    sceneFromText (text, faceId, voice) {
      var clip = this.clipFromText(text, faceId, voice)

      var newScene = {}
      if (text.length) {
        newScene.clips = [clip]
      }
      return new Scene(newScene)
    },
    onTTS: function (args) {
      this.bPlayAgainAvailable = true
      var scene = this.sceneFromText(args.text, args.faceId, Voice(args.voice))
      var onFinishedTTS = () => {
        if (args.onFinished) {
          args.onFinished()
        }
        this.onFinishedTTS = null
      }
      scene.playScene(onFinishedTTS)
      this.onFinishedTTS = onFinishedTTS
    }
  },
  created: function () {
    this.bBrowserCompatible = helper.isBrowserCompatible()
    this.bTTSEnabled = helper.isTTSAvailable()
    this.bLocalStorageAvailable = helper.isLocalStorageAvailable()
    if (!this.bBrowserCompatible) {
      this.loading = false
      return
    }
    SmoothContext.eventEmitter.addListener('appendHTML', this.onAppendHTML)
    SmoothContext.eventEmitter.addListener('clearHTML', this.onClearHTML)
    SmoothContext.eventEmitter.addListener('startListening', this.onStartListening)
    SmoothContext.eventEmitter.addListener('stopListening', this.onStopListening)
    SmoothContext.eventEmitter.addListener('displayMatches', this.onDisplayMatches)
    SmoothContext.eventEmitter.addListener('hideMatches', this.onHideMatches)
    SmoothContext.eventEmitter.addListener('requestFace', this.onFaceRequested)
    SmoothContext.eventEmitter.addListener('finished', this.onFinished)
    SmoothContext.eventEmitter.addListener('loading', this.onLoading)
    SmoothContext.eventEmitter.addListener('tts', this.onTTS)
    Scene.eventEmitter.addListener('clipstart', this.onClipStartEvent)

    this.speechRecognitionPermissionGranted = false
    if (helper.isLocalStorageAvailable()) {
      this.speechRecognitionPermissionGranted = window.localStorage.getItem('webkitSpeechRecognitionPermission')
    }
    // Warm the system up to prevent delayed recofnition on first response
    // @todo: do special message when we need permission
    if (this.speechRecognitionPermissionGranted) {
      // eslint-disable-next-line new-cap
      var startupRecognition = new window.webkitSpeechRecognition()
      startupRecognition.onstart = (event) => {
        startupRecognition.stop()
      }
      startupRecognition.start()
    }
  },
  beforeDestroy: function () {
    Scene.stop()
    SmoothContext.eventEmitter.removeListener('appendHTML', this.onAppendHTML)
    SmoothContext.eventEmitter.removeListener('clearHTML', this.onClearHTML)
    SmoothContext.eventEmitter.removeListener('startListening', this.onStartListening)
    SmoothContext.eventEmitter.removeListener('stopListening', this.onStopListening)
    SmoothContext.eventEmitter.removeListener('displayMatches', this.onDisplayMatches)
    SmoothContext.eventEmitter.removeListener('hideMatches', this.onHideMatches)
    SmoothContext.eventEmitter.removeListener('requestFace', this.onFaceRequested)
    SmoothContext.eventEmitter.removeListener('finished', this.onFinished)
    SmoothContext.eventEmitter.removeListener('loading', this.onLoading)
    SmoothContext.eventEmitter.removeListener('tts', this.onTTS)
    Scene.eventEmitter.removeListener('clipstart', this.onClipStartEvent)
  },
  mounted: function () {
    this.currentId = this.id
    if (this.initialized) {
      this.onInitialized()
    }
  },
  watch: {
    initialized: function (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.currentId = this.id
        this.onInitialized()
      }
    }
  }
}
</script>
<style >
.storytext {
  font-size: 1.2em;
  text-align: left;
}
.storychoice {
  font-size: 1.4em;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Playback/SmoothPlayback.vue